/* GOSS header overlay — state driver for the transparent homepage header. */
(function () {
  var body = document.body;
  if (!body.classList.contains('goss-overlay-home')) return;

  var announcement = document.querySelector('.announcement-bar-section');
  var header = document.querySelector('.section-header');

  function measure() {
    var offset = (announcement ? announcement.offsetHeight : 0) + (header ? header.offsetHeight : 0);
    document.documentElement.style.setProperty('--goss-overlay-offset', offset + 'px');
  }

  function onScroll() {
    body.classList.toggle('goss-header-solid', (window.scrollY || 0) > 24);
  }

  [announcement, header].forEach(function (el) {
    if (!el) return;
    el.addEventListener('mouseenter', function () { body.classList.add('goss-header-hover'); });
    el.addEventListener('mouseleave', function () { body.classList.remove('goss-header-hover'); });
    el.addEventListener('focusin', function () { body.classList.add('goss-header-hover'); });
    el.addEventListener('focusout', function () { body.classList.remove('goss-header-hover'); });
  });

  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
  measure();
  onScroll();
})();
